import { createContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import Cookie from 'js-cookie'
import axiosInstance from "../services/api/axiosInstance";
import { IoIosInformationCircleOutline } from "react-icons/io";
import { decryptData, encryptData } from "Security/Crypto/Crypto";

const CommonContext = createContext();

export const DataProvider = ({ children }) => {
  // home page states
  const RecordsPerPage = 10;
  const selectedcardlinkglobal = `${process.env.REACT_APP_SHARE_BASEURL}/professional/all_jobs?job_id=`
  const [searchResult, setSearchResult] = useState(false);
  const [isSearched, setIsSearched] = useState(false);
  const [isMellieSearch, setIsMellieSearch] = useState(false);
  const [isSharedJob, setIsSharedJob] = useState(false);
  const [isSelectedJob, setIsSelectedJob] = useState(false);
  const [professionalJobSearching, setprofessionalJobSearching] = useState(false);
  const [professionalJobClearing, setprofessionalJobClearing] = useState(false);
  const [resumeDataFromResponse, setResumeDataFromResponse] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [profilePicture, setProfilePicture] = useState(`${process.env.REACT_APP_SECOND_CAREERS_CDN}professional/profile-pic/default_profile_picture.png`);
  const [sortBy, setSortBy] = useState("");
  const [disableProfilePictureDelete, setDisableProfilePictureDelete] = useState(false);
  const [isProfilePictureUploaded, setIsProfilePictureUploaded] = useState(false);
  const [selectedCardIndex, setSelectedCardIndex] = useState(0);
  const [gettingResponse, setGettingResponse] = useState(false);
  const [FilterArray, setFilterArray] = useState({});
  const [cardArray, setCardArray] = useState([]);
  const [cardArrayDuplicate, setCardArrayDuplicate] = useState([]);
  const [cardArrayDuplicateSearch, setCardArrayDuplicateSearch] = useState([]);
  const [selectedCardData, setSelectedCardData] = useState([]);
  const [answers, setAnswer] = useState([]);
  const [selectedSkeleton, setSelectedSkeleton] = useState(false);
  const [refreshId, setRefreshId] = useState(0);
  const [refreshAction, setRefreshAction] = useState(false);
  const [applyFilterResponse, setapplyFilterResponse] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [isSmallDevice, setIsSmallDevice] = useState(false);
  const [jobcardId, setJobcardId] = useState(0);
  const [selectedCardPath, setSelectedCardPath] = useState("");
  const [selectedCarrdLink, setSelectedCardLink] = useState("");
  const [reCall, setRecall] = useState(false);
  const [skillData, setSkillData] = useState([]);
  const [locationData, setLocationData] = useState([]);
  const [sectorData, setSectorData] = useState([]);
  const [specialisationData, setSpecialisationData] = useState([]);
  const [reCallId, setRecallID] = useState(0);
  const [filterRefreshId, setFilterRefreshId] = useState(0);
  const [recommendedRefreshId, setRecommendedRefreshId] = useState(0);
  const [applyFilterCount, setApplyFilterCount] = useState(0);
  const [paginationpageCount, setPaginationpageCount] = useState(0);
  const [paginationTotalCount, setpaginationTotalCount] = useState(0)
  const [filteringObject, setFilteringObject] = useState({});
  const [saveJobLoading, setSaveJobLoading] = useState(false);
  const [applyJobLoading, setApplyJobLoading] = useState(false);
  const [editLocation, setEditLocation] = useState({
    city: "",
    country: "",
  });
  const [recommendedStatus, setRecommendedStatus] = useState({
    recommended_by: "",
    sc_recommended_notes: ""
  })
  const [recommendationBelowSixtyPercentage, setRecommendationBelowSixtyPercentage] = useState(false);
  const [enhancedCoverLetterData, setEnhancedCoverLetterData] = useState("");
  const [enhancedCoverLetterDataForPDF, setEnhancedCoverLetterDataForPDF] = useState("");
  const [coverLetterLoading, setCoverLetterLoading] = useState(false);
  const [enhancedCoverLetter, setEnhancedCoverLetter] = useState(false);
  const [isApplyFilterClicked, setIsApplyFilterClicked] = useState(false)
  const [skills, setSkills] = useState([]);
  const [sectors, setSectors] = useState([]);
  const [specialization, setSpecialization] = useState([]);
  const [location, setLocation] = useState([]);
  const [workplaceType, setWorkplaceType] = useState([]);
  const [jobTypee, setJobTypee] = useState([]);
  const [schedule, setSchedule] = useState([]);
  const [clearFilter, setClearFilter] = useState(false);
  const [skillsSearch, setSkillsSearch] = useState(true);
  const [sectorSearch, setSectorSearch] = useState(true);
  const [speciSearch, setSpeciSearch] = useState(true);
  const [LocationSearch, setLocationSearch] = useState(true);
  const [subscriptionExpiredShow, setSubscriptionExpired] = useState(false);
  const [applyNowProfilePercent, setApplyNowProfilePercent] = useState(0)

  // Sort by for home 
  const [filter, setFilter] = useState("");
  const [sortByForPagination, setSortByForPagination] = useState("")

  // jOY RIDE
  const professionalHome = "professionalHome";
  const professionalLearning = "professionalLearning";
  const professionalCommunity = "professionalCommunity";
  const professionalProfileDropdown = "professionalProfileDropdown";
  const professionalJobs = "professionalJobs"

  const getHomeAll = async (pagination, currentPageProps, sortByType) => {
    try {
      setAnswer([]);
      if (pagination === undefined) {
        var obj = {
          page_number: 1,
          professional_id: 0,
          key: sortByType ? "sort" : "",
          param: sortByType ? sortByType : ""
        }
      } else {
        obj = {
          page_number: currentPageProps,
          professional_id: 0,
          key: sortByType ? "sort" : "",
          param: sortByType ? sortByType : ""
        }
        setapplyFilterResponse(true);
      }

      const response = await axiosInstance.post("/professional_dashboard", obj);
      setRefreshAction(false);

      if (window.location.pathname === "/professional/all_jobs" || window.location.pathname === "/professional/job_Details") {
        if (response.data.error_code === 0) {
          setpaginationTotalCount(response.data.data.total_count)
          if (response.data.data.total_count >= 10) {
            var homeallPaginationCount = Math.ceil((response.data.data.total_count / 10));
            setPaginationpageCount(homeallPaginationCount);
          } else {
            setPaginationpageCount(1);
          }

          // setting left side filter datas 
          if (pagination === undefined) {
            setFilterArray(response.data.data);
            //skill data
            var orderingemployerSkills = response.data.data.skill.sort();

            var professionalSkillsConvertion = orderingemployerSkills.map((v, i) => {
              return { value: i + 1, label: v, disabled: false };
            });
            setSkillData(professionalSkillsConvertion);

            //location Data
            var professionallocationConvertion = response.data.data.location.map((v, i) => {
              return { value: i + 1, label: v, disabled: false };
            });
            setLocationData(professionallocationConvertion);

            //sector Data
            var professionalsectorConvertion = response.data.data.sector.map((v, i) => {
              return { value: i + 1, label: v, disabled: false };
            });
            setSectorData(professionalsectorConvertion);

            //specialisation Data
            var professionalspecialisationConvertion = response.data.data.specialisation.map((v, i) => {
              return { value: i + 1, label: v, disabled: false };
            });
            setSpecialisationData(professionalspecialisationConvertion);
          }

          //main card content setting
          if (response.data.data.job_details.length > 0) {
            setSelectedCardLink(`${selectedcardlinkglobal}${encryptData(response.data.data.job_details[0].id)}`);
            setCardArray(response.data.data.job_details);
            setCardArrayDuplicate(response.data.data.job_details);
            setCardArrayDuplicateSearch(response.data.data.job_details);
            setSelectedCardData([response.data.data.job_details[0]]);
            setApplyNowProfilePercent(response.data.data.job_details[0]?.profile_percentage)

            response.data.data.job_details[0].questions.map((v) => {
              setAnswer((prevState) => [
                ...prevState,
                { question_id: v.id, answer: "" },
              ]);
            });

            setSearchResult(false);
            setprofessionalJobClearing(false);
            setGettingResponse(true);

            var getLocalStorageId = Cookie.get("job_id") ? decryptData(Cookie.get("job_id")) : '';
            if (getLocalStorageId) {
              handleSelectedCardData(getLocalStorageId);
            }
          } else {
            setCardArray([]);
            setAnswer([]);
            setSelectedCardData([]);
            setCardArrayDuplicate([]);
            setCardArrayDuplicateSearch([]);
            setGettingResponse(true);
            setSelectedCardIndex(0);
          }
          setGettingResponse(true);
        } else {
          setSelectedCardIndex(0);
        }
        setGettingResponse(true);
      }
      setGettingResponse(true);
      setprofessionalJobClearing(false)
      setapplyFilterResponse(false)
      setSearchInput('');
    } catch (err) {
      console.log(err)
    }
  };

  const getRecommendedData = async () => {
    try {
      const response = await axiosInstance.get("/professional_recommended");
      setRefreshAction(false);
      if (window.location.pathname === "/professional/recommended_jobs") {
        if (response.data.error_code === 0) {
          setApplyNowProfilePercent(response.data.data.profile_percentage)
          if (response.data.data.profile_percentage < 60) {
            setRecommendationBelowSixtyPercentage(true);
          } else {
            setRecommendationBelowSixtyPercentage(false);
          }

          if (response.data.data?.job_details?.length) {
            setSelectedCardLink(`${selectedcardlinkglobal}${encryptData(response.data.data.job_details[0].id)}`)
            setRecommendedStatus({
              ...recommendedStatus,
              recommended_by: response.data.data.job_details[0].recommended_by,
              sc_recommended_notes: response.data.data.job_details[0].sc_recommended_notes
            });

            if (response.data.data.job_details.length > 0) {
              setCardArray(response.data.data.job_details);
              setCardArrayDuplicate(response.data.data.job_details);
              setCardArrayDuplicateSearch(response.data.data.job_details);

              var getLocalStorageId = Cookie.get("recommended_job_id") ? decryptData(Cookie.get("recommended_job_id")) : '';
              if (getLocalStorageId) {
                handleSelectedCardData(getLocalStorageId);
              } else {
                setSelectedCardData([response.data.data.job_details[0]]);
                response.data.data.job_details[0].questions.map((v) => {
                  setAnswer((prevState) => [
                    ...prevState,
                    { question_id: v.id, answer: "" },
                  ]);
                });
              }

              setapplyFilterResponse(false);
              setSearchResult(false);
              setprofessionalJobClearing(false);
              setSearchInput('');
            } else {
              setCardArray([]);
              setAnswer([]);
              setSelectedCardData([]);
              setCardArrayDuplicate([]);
              setCardArrayDuplicateSearch([]);
              setGettingResponse(true);
            }
            setGettingResponse(true);
          } else {
            setCardArray([]);
            setAnswer([]);
            setSelectedCardData([]);
            setCardArrayDuplicate([]);
            setCardArrayDuplicateSearch([]);
            setGettingResponse(true);
          }

          setGettingResponse(true);
          setSelectedCardIndex(0);
        } else {
          setSelectedCardIndex(0);
          setCardArray([]);
          setAnswer([]);
          setSelectedCardData([]);
          setCardArrayDuplicate([]);
          setCardArrayDuplicateSearch([]);
          setGettingResponse(true);

          var getRecommendedLocalStorageId = Cookie.get("recommended_job_id");
          if (getRecommendedLocalStorageId) {
            Cookie.remove("recommended_job_id");
          }
        }
      }
      setprofessionalJobClearing(false)
      setapplyFilterResponse(false)
    } catch (err) {
      console.log(err)

      var getRecommendedLocalStorageId = Cookie.get("recommended_job_id");
      if (getRecommendedLocalStorageId) {
        Cookie.remove("recommended_job_id");
      }
    }
  };

  const getAppliedDatas = async (pagination, currentPageProps, sortByType) => {
    try {
      var obj = {
        page_number: currentPageProps || 1,
        professional_id: 0,
        key: sortByType ? "sort" : "",
        param: sortByType ? sortByType : ""
      }
      setapplyFilterResponse(true)

      const response = await axiosInstance.post("/professional_applied_jobs", obj);
      setRefreshAction(false)
      setAnswer([])
      if (window.location.pathname === "/professional/applied_jobs") {
        if (response.data.error_code === 0) {
          if (response.data.data.job_details && response.data.data.job_details.length > 0) {
            setSelectedCardLink(`${selectedcardlinkglobal}${encryptData(response.data.data.job_details[0].id)}`)
            setCardArray(response.data.data.job_details)
            setCardArrayDuplicate(response.data.data.job_details)
            setSelectedCardData([response.data.data.job_details[0]])

            var appliedPaginationCount = Math.ceil((response.data.data.job_details[0].total_count / 10))
            setPaginationpageCount(appliedPaginationCount)
            setpaginationTotalCount(response.data.data.job_details[0].total_count)
            setCardArrayDuplicateSearch(response.data.data.job_details)
            setGettingResponse(true);
          }
          else {
            setCardArray([])
            setCardArrayDuplicate([])
            setSelectedCardData([])
            setCardArrayDuplicateSearch([])
            setGettingResponse(true);
            setPaginationpageCount(1)
          }
          setapplyFilterResponse(false);
          setSearchResult(false);
          setprofessionalJobClearing(false);
          setSearchInput('');
        } else {
          setSearchResult(false);
          setprofessionalJobClearing(false);
          setSearchInput('');
          setapplyFilterResponse(false)
        }
      }
    } catch (err) {
      console.log(err)
    }
  };

  const getSavedDatas = async (pagination, currentPageProps, sortByType) => {
    try {
      if (pagination === undefined) {
        var obj = {
          page_number: 1,
          professional_id: 0,
          key: sortByType ? "sort" : "",
          param: sortByType ? sortByType : ""
        }
      } else {
        setGettingResponse(false)
        var obj = {
          page_number: currentPageProps,
          professional_id: 0,
          key: sortByType ? "sort" : "",
          param: sortByType ? sortByType : ""
        }
      }

      const response = await axiosInstance.post("/professional_saved_jobs", obj);
      if (window.location.pathname === "/professional/saved_jobs") {
        if (response.data.error_code === 0) {
          if (response.data.data.length > 0) {

            if (response.data.data[0].total_count > 10) {
              var savedPaginationCount = Math.ceil((response.data.data[0].total_count / 10))
              setpaginationTotalCount(response.data.data[0].total_count)
              setPaginationpageCount(savedPaginationCount)
            } else {
              setPaginationpageCount(1)
            }

            if (response.data.data.length > 0) {
              setApplyNowProfilePercent(response.data.data[0]?.profile_percentage)
              setCardArray(response.data.data);
              setCardArrayDuplicate(response.data.data);
              setCardArrayDuplicateSearch(response.data.data);
              setSelectedCardData([response.data.data[0]]);
              response.data.data[0].questions.map((v) => {
                setAnswer((prevState) => [
                  ...prevState,
                  { question_id: v.id, answer: "" },
                ]);
              });

              setSelectedCardLink(`${selectedcardlinkglobal}${encryptData(response.data.data[0].id)}`);
            } else {
              setCardArray([]);
              setCardArrayDuplicate([]);
              setCardArrayDuplicateSearch([]);
              setSelectedCardData([]);
              setAnswer([]);
            }

            setGettingResponse(true);
            setRecall(false);
          } else {
            setCardArray([]);
            setCardArrayDuplicate([]);
            setCardArrayDuplicateSearch([]);
            setAnswer([]);
            setCurrentPage(1);
            setPaginationpageCount(1)
            setGettingResponse(true);
          }
          setapplyFilterResponse(false);
          setSearchResult(false);
          setprofessionalJobClearing(false);
          setSearchInput('');
        } else {
          setSearchResult(false);
          setprofessionalJobClearing(false);
          setSearchInput('');
          setapplyFilterResponse(false)
        }
      }
    } catch (err) {
      console.log(err)
    }
  };

  const resetMellieSearch_whenSearching = () => {
    const ChangeSkillDisableFalse = skillData.map((skills) => {
      return { ...skills, disabled: false }
    })
    setSkillData(ChangeSkillDisableFalse)

    const ChangeSectorDisableFalse = sectorData.map((sectors) => {
      return { ...sectors, disabled: false }
    })
    setSectorData(ChangeSectorDisableFalse)

    const ChangeSpeciDisableFalse = specialisationData.map((specilization) => {
      return { ...specilization, disabled: false }
    })
    setSpecialisationData(ChangeSpeciDisableFalse)

    const ChangeLocationDisableFalse = locationData.map((location) => {
      return { ...location, disabled: false }
    })
    setLocationData(ChangeLocationDisableFalse)

    setSkills([]);
    setSectors([]);
    setSpecialization([]);
    setLocation([]);
    setWorkplaceType([]);
    setJobTypee([]);
    setSchedule([]);

    var rmv = document.querySelectorAll('input[type=checkbox]')
    for (var i = 0; i < rmv.length; i++) {
      rmv[i].checked = false
    }

    setAnswer([]);
  }

  const initializeReset = () => {
    setApplyFilterCount(0);
    setCurrentPage(0);
    setSkillsSearch(true)
    setSectorSearch(true)
    setSpeciSearch(true)
    setLocationSearch(true)

    const ChangeSkillDisableFalse = skillData.map((skills) => {
      return { ...skills, disabled: false }
    })
    setSkillData(ChangeSkillDisableFalse)

    const ChangeSectorDisableFalse = sectorData.map((sectors) => {
      return { ...sectors, disabled: false }
    })
    setSectorData(ChangeSectorDisableFalse)

    const ChangeSpeciDisableFalse = specialisationData.map((specilization) => {
      return { ...specilization, disabled: false }
    })
    setSpecialisationData(ChangeSpeciDisableFalse)

    const ChangeLocationDisableFalse = locationData.map((location) => {
      return { ...location, disabled: false }
    })
    setLocationData(ChangeLocationDisableFalse)

    setSkills([]);
    setSectors([]);
    setSpecialization([]);
    setLocation([]);
    setWorkplaceType([]);
    setJobTypee([]);
    setSchedule([]);

    var rmv = document.querySelectorAll('input[type=checkbox]')
    for (var i = 0; i < rmv.length; i++) {
      rmv[i].checked = false
    }

    setAnswer([]);
    setIsApplyFilterClicked(false)
  }

  const professionalMellieSearch = async (object, pagination) => {

    try {
      var submitData = {}
      if (pagination) {
        submitData = { ...object, page_number: pagination };
      } else {
        submitData = { ...object, page_number: 1 };
      }

      const response = await axiosInstance.post("/admin_jobs_meilisearch", submitData)
      setGettingResponse(true);
      setapplyFilterResponse(false);
      setRefreshAction(false);

      if (response.data.error_code === 0) {
        //close Filter box in mobile screen
        document.getElementById('close_mobile_filter')?.click()

        if (response.data.data?.job_details?.length) {
          var applyFilterPaginationCount = Math.ceil((response.data.data.total_count / 10))
          setpaginationTotalCount(response.data.data.total_count)
          setPaginationpageCount(applyFilterPaginationCount)

          setCardArray(response.data.data.job_details);
          setCardArrayDuplicate(response.data.data.job_details);
          setCardArrayDuplicateSearch(response.data.data.job_details);

          setSelectedCardData([response.data.data.job_details[0]]);
          setApplyNowProfilePercent(response.data.data.percentage)
          response.data.data.job_details[0]?.questions?.map((v) => {
            setAnswer((prevState) => [
              ...prevState,
              { question_id: v.id, answer: "" },
            ]);
          });
        } else {
          setCardArray([]);
          setAnswer([]);
          setSelectedCardData([]);
          setCardArrayDuplicate([]);
          setCardArrayDuplicateSearch([]);
          setGettingResponse(true);
          setSelectedCardIndex(0);
          setPaginationpageCount(1);
        }
      } else {
        toast.error(response.data.message);
      }
    } catch (err) {
      console.log(err)
    }
  };


  const handleSelectedCardData = async (cardId, isJobSaving) => {
    if (window.location.pathname === "/professional/all_jobs" || window.location.pathname === "/professional/recommended_jobs" || window.location.pathname === "/professional/saved_jobs" || window.location.pathname === "/professional/applied_jobs") {
      setSelectedCardPath(window.location.pathname)
    }
    setAnswer([])

    //if i save job the isJobSaving="job-saving" otherwise it will be isJobSaving=undefined
    if (isJobSaving === undefined) {
      setSelectedSkeleton(true)
      setSelectedCardData([])
    }

    setSelectedCardLink(`${selectedcardlinkglobal}${encryptData(cardId)}`)
    try {
      let jobId = { job_id: cardId }
      const response = await axiosInstance.post("/selected_job_details", jobId)

      if (response.data.error_code === 0) {
        setSelectedCardData(response.data.data)
        setSelectedSkeleton(false)
        setJobcardId(cardId)
        setApplyNowProfilePercent(response.data.data[0]?.profile_percentage)
        if (window.location.pathname === "/professional/recommended_jobs" || window.location.pathname === "/professional/job_Details") {
          setRecommendedStatus({
            ...recommendedStatus,
            recommended_by: "2nd Career Recommendation",
            sc_recommended_notes: response.data.data[0].sc_recommended_notes
          });
        } else {
          setRecommendedStatus({
            ...recommendedStatus,
            recommended_by: "",
            sc_recommended_notes: ""
          });
        }

        response.data.data[0].questions.map((v) => {
          setAnswer((prevState) => [
            ...prevState,
            { question_id: v.id, answer: "" },
          ]);
        });
      }
      else {
        setSelectedCardData([])
        setSelectedSkeleton(false)
        toast.error(response.data.message)
      }

      var getLocalStorageId = Cookie.get("job_id") ? decryptData(Cookie.get("job_id")) : '';
      if (getLocalStorageId) {
        setapplyFilterResponse(false)
        setGettingResponse(true);
        setSelectedCardIndex(0);
        Cookie.remove("job_id");
      }

      var getRecommendedLocalStorageId = decryptData(Cookie.get("recommended_job_id"));
      if (getRecommendedLocalStorageId) {
        setapplyFilterResponse(false)
        setGettingResponse(true);
        setSelectedCardIndex(0);
        Cookie.remove("recommended_job_id");
      }
      setSaveJobLoading(false)
    } catch (err) {
      console.log(err)
    }
  }

  const handleCoverLetter = async () => {
    setCoverLetterLoading(true);
    setEnhancedCoverLetter(true);
    try {
      const data = {
        company_name: selectedCardData.length > 0 ? selectedCardData[0].company_name : '',
        job_title: selectedCardData.length > 0 ? selectedCardData[0].job_title : '',
        country: selectedCardData.length > 0 ? selectedCardData[0].country : '',
        city: selectedCardData.length > 0 ? selectedCardData[0].city : '',
        job_desc: selectedCardData.length > 0 ? selectedCardData[0].job_desc : ''
      }


      const res = await axiosInstance.post("/generate_cover_letter", data);

      if (res.data.error_code === 0) {
        setCoverLetterLoading(false);
        const replaceStrings = res.data.data.replace(/\n/g, '<br/>')

        setEnhancedCoverLetterData(replaceStrings);
      } else {
        setCoverLetterLoading(false);
        setEnhancedCoverLetter(false);
      }
    } catch (err) {
      console.log(err)
    }
  }

  const sendingDataForProfessionalSearch = async (endpoint, params) => {
    setprofessionalJobSearching(true);

    try {
      const response = await axiosInstance.post(endpoint, params);

      if (response.data.error_code === 0) {
        if (response.data.data.job_details && response.data.data.job_details.length > 0) {
          setSelectedCardLink(`${selectedcardlinkglobal}${encryptData(response.data.data.job_details[0].id)}`)
          setCardArray(response.data.data.job_details)
          setCardArrayDuplicate(response.data.data.job_details)
          setSelectedCardData([response.data.data.job_details[0]])

          setApplyNowProfilePercent(response.data.data.job_details[0]?.profile_percentage)

          const appliedPaginationCount = Math.ceil((response.data.data.total_count / 10))
          setpaginationTotalCount(response.data.data.total_count)
          setPaginationpageCount(appliedPaginationCount)

          setCardArrayDuplicateSearch(response.data.data.job_details)

          setGettingResponse(true)
        }
        else {
          setCardArray([])
          setCardArrayDuplicate([])
          setSelectedCardData([])
          setCardArrayDuplicateSearch([])
          setGettingResponse(true);
          setPaginationpageCount(1)
        }
        setapplyFilterResponse(false);
        setprofessionalJobSearching(false);
      } else {
        setCardArray([])
        setCardArrayDuplicate([])
        setSelectedCardData([])
        setCardArrayDuplicateSearch([])

        setPaginationpageCount(1)
        setapplyFilterResponse(false)
        setprofessionalJobSearching(false);
      }
    } catch (err) {
      console.log(err)
    }
  }

  //  Pricing****************************************************************************************************************************************************

  const [checkOutStatus, setCheckOutStatus] = useState({
    paymentStatus: '',
    productPlan: ''
  })

  const [country, setCountry] = useState("")

  const [countryLoading, setCountryLoading] = useState(false)

  useEffect(() => {
    if (navigator.geolocation) {

      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          updateCheckoutStatus(latitude, longitude)
        },
        (error) => {
          updateCheckoutStatus()
        }
      );
    }

  }, []);

  const updateCheckoutStatus = async (lat, long) => {
    var getCountryParameters;
    try {
      if (lat && long) {
        getCountryParameters = {
          lat: lat,
          lon: long
        };
      }

      else {
        getCountryParameters = {
          "lat": "43.000000",
          "lon": "-75.000000"
        };
      }


      setCountryLoading(true)
      const response = await axiosInstance.post("/get_checkout_status", getCountryParameters);
      if (response.data.error_code === 0) {
        setCountryLoading(false)
        setCheckOutStatus({
          paymentStatus: response.data.data.payment_status,
          productPlan: response.data.data.product_plan
        })
        setCountry(response.data.data.country)
      } else {
        toast(response.data.message, {
          icon: (
            <h4><IoIosInformationCircleOutline className="brand-color me-1" /></h4>
          )
        });
      }

    } catch (error) {
      console.log(error)
    }
  }

  return (
    <CommonContext.Provider
      value={{
        // Pricing
        country,
        setCountry,
        checkOutStatus,
        setCheckOutStatus,
        countryLoading,
        setCountryLoading,

        // sort by
        isSearched, setIsSearched,
        isMellieSearch, setIsMellieSearch,
        professionalMellieSearch,
        isSharedJob, setIsSharedJob,
        isSelectedJob, setIsSelectedJob,

        filter, setFilter,
        getHomeAll,
        sortByForPagination,
        setSortByForPagination,
        applyNowProfilePercent,
        isApplyFilterClicked, setIsApplyFilterClicked,
        resumeDataFromResponse, setResumeDataFromResponse,
        recommendationBelowSixtyPercentage, setRecommendationBelowSixtyPercentage,
        recommendedStatus, setRecommendedStatus,
        cardArray, setCardArray,
        FilterArray, setFilterArray,
        selectedCardData, setSelectedCardData,
        gettingResponse, setGettingResponse,
        cardArrayDuplicate, setCardArrayDuplicate,
        sortBy, setSortBy,
        selectedSkeleton, setSelectedSkeleton,
        answers, setAnswer,
        refreshId, setRefreshId,
        refreshAction, setRefreshAction,
        applyFilterResponse, setapplyFilterResponse,
        cardArrayDuplicateSearch, setCardArrayDuplicateSearch,
        selectedCardIndex, setSelectedCardIndex,
        searchInput, setSearchInput,
        isSmallDevice, setIsSmallDevice,
        getHomeAll, getAppliedDatas,
        RecordsPerPage,
        jobcardId, setJobcardId,
        selectedCardPath, setSelectedCardPath,
        getRecommendedData,
        profilePicture, setProfilePicture,
        selectedcardlinkglobal,
        selectedCarrdLink, setSelectedCardLink,
        getSavedDatas,
        handleSelectedCardData,
        reCall, setRecall,
        skillData, setSkillData,
        locationData, setLocationData,
        sectorData, setSectorData,
        specialisationData, setSpecialisationData,
        disableProfilePictureDelete, setDisableProfilePictureDelete,
        currentPage, setCurrentPage,
        reCallId, setRecallID,
        isProfilePictureUploaded, setIsProfilePictureUploaded,
        editLocation, setEditLocation,
        applyFilterCount, setApplyFilterCount,
        // handleApplyFilter,
        filteringObject, setFilteringObject,
        filterRefreshId, setFilterRefreshId,
        recommendedRefreshId, setRecommendedRefreshId,
        saveJobLoading, setSaveJobLoading,
        applyJobLoading, setApplyJobLoading,
        paginationpageCount, setPaginationpageCount,
        paginationTotalCount, setpaginationTotalCount,
        handleCoverLetter,
        enhancedCoverLetterData, setEnhancedCoverLetterData,
        coverLetterLoading, setCoverLetterLoading,
        enhancedCoverLetter, setEnhancedCoverLetter,
        enhancedCoverLetterDataForPDF, setEnhancedCoverLetterDataForPDF,
        sendingDataForProfessionalSearch,
        searchResult, setSearchResult,
        professionalJobClearing, setprofessionalJobClearing,
        professionalJobSearching, setprofessionalJobSearching,

        resetMellieSearch_whenSearching,
        initializeReset,
        skills, setSkills,
        sectors, setSectors,
        specialization, setSpecialization,
        location, setLocation,
        workplaceType, setWorkplaceType,
        jobTypee, setJobTypee,
        schedule, setSchedule,
        clearFilter, setClearFilter,
        skillsSearch, setSkillsSearch,
        sectorSearch, setSectorSearch,
        speciSearch, setSpeciSearch,
        LocationSearch, setLocationSearch,
        subscriptionExpiredShow, setSubscriptionExpired,

        // JOY RIDE
        professionalHome,
        professionalLearning,
        professionalCommunity,
        professionalProfileDropdown,
        professionalJobs
      }}
    >
      {children}
    </CommonContext.Provider>
  );
};

export default CommonContext;
